/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";
import ODataStore from "devextreme/data/odata/store";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SalesOrderListService = {
  dataSourceConfig(url, params) {
    // var url = "api/SalesOrderList";
    return ApiService.createDataSource(url, params);
  },

  async getUserDefaultSalesRepresentative() {
    var url = "api/UserDefaultSalesRepresentative";
    const requestScreenData = {
      url: "api/UserDefaultSalesRepresentative",
      // select: ["SalesRepresentativeFullName"],
    };
    return await ApiService.oDataGet(requestScreenData);
  },
};

export { SalesOrderListService };
